@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.home.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/mobile_wallet.feature.home.generated.resources/"

internal val Res.string.feature_home_account_error: StringResource by lazy {
      StringResource("string:feature_home_account_error", "feature_home_account_error", setOf(
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 10, 174),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 102),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10, 178),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 10, 82),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 10, 78),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 10, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 78),
      ))
    }

internal val Res.string.feature_home_account_number: StringResource by lazy {
      StringResource("string:feature_home_account_number", "feature_home_account_number", setOf(
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 185, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 101, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 113, 63),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 189, 71),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 93, 55),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 89, 55),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 101, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89, 51),
      ))
    }

internal val Res.string.feature_home_account_success: StringResource by lazy {
      StringResource("string:feature_home_account_success", "feature_home_account_success", setOf(
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 281, 184),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 157, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 177, 72),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 261, 192),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 149, 76),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 145, 72),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 169, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141, 72),
      ))
    }

internal val Res.string.feature_home_account_type: StringResource by lazy {
      StringResource("string:feature_home_account_type", "feature_home_account_type", setOf(
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 466, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 242, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 250, 53),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 454, 77),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 226, 49),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 218, 53),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 254, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214, 49),
      ))
    }

internal val Res.string.feature_home_arrow_up: StringResource by lazy {
      StringResource("string:feature_home_arrow_up", "feature_home_arrow_up", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 264, 41),
      ))
    }

internal val Res.string.feature_home_autopay: StringResource by lazy {
      StringResource("string:feature_home_autopay", "feature_home_autopay", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 306, 40),
      ))
    }

internal val Res.string.feature_home_coin_image: StringResource by lazy {
      StringResource("string:feature_home_coin_image", "feature_home_coin_image", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 347, 39),
      ))
    }

internal val Res.string.feature_home_desc: StringResource by lazy {
      StringResource("string:feature_home_desc", "feature_home_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 564, 305),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 296, 165),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 304, 173),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 532, 349),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 276, 165),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 272, 141),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 308, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 387, 145),
      ))
    }

internal val Res.string.feature_home_failed_to_load_accounts: StringResource by lazy {
      StringResource("string:feature_home_failed_to_load_accounts", "feature_home_failed_to_load_accounts", setOf(
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 870, 208),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 462, 104),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 478, 116),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 882, 212),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 442, 96),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 414, 100),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 450, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 533, 100),
      ))
    }

internal val Res.string.feature_home_loading: StringResource by lazy {
      StringResource("string:feature_home_loading", "feature_home_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1079, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 567, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 595, 44),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1095, 72),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 539, 36),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 515, 44),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 567, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 634, 40),
      ))
    }

internal val Res.string.feature_home_mark_default: StringResource by lazy {
      StringResource("string:feature_home_mark_default", "feature_home_mark_default", setOf(
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1144, 129),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 608, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 640, 61),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1168, 149),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 576, 65),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 560, 61),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 608, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 675, 53),
      ))
    }

internal val Res.string.feature_home_no_account: StringResource by lazy {
      StringResource("string:feature_home_no_account", "feature_home_no_account", setOf(
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1274, 139),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 678, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 702, 59),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1318, 95),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 642, 71),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 622, 63),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 674, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 729, 59),
      ))
    }

internal val Res.string.feature_home_request: StringResource by lazy {
      StringResource("string:feature_home_request", "feature_home_request", setOf(
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1501, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 805, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 825, 40),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1501, 76),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 765, 36),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 745, 40),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 793, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 844, 40),
      ))
    }

internal val Res.string.feature_home_request_money: StringResource by lazy {
      StringResource("string:feature_home_request_money", "feature_home_request_money", setOf(
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1414, 86),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 746, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 762, 62),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1414, 86),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 714, 50),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 686, 58),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 746, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 789, 54),
      ))
    }

internal val Res.string.feature_home_send: StringResource by lazy {
      StringResource("string:feature_home_send", "feature_home_send", setOf(
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1642, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 898, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 926, 37),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1650, 45),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 850, 33),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 838, 33),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 874, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 933, 33),
      ))
    }

internal val Res.string.feature_home_send_money: StringResource by lazy {
      StringResource("string:feature_home_send_money", "feature_home_send_money", setOf(
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1570, 71),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 846, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 866, 59),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1578, 71),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 802, 47),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 786, 51),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 830, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 885, 47),
      ))
    }

internal val Res.string.feature_home_view_more: StringResource by lazy {
      StringResource("string:feature_home_view_more", "feature_home_view_more", setOf(
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1688, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 932, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 964, 42),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1696, 62),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 884, 54),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 872, 42),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 908, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 967, 42),
      ))
    }

internal val Res.string.feature_home_wallet_balance: StringResource by lazy {
      StringResource("string:feature_home_wallet_balance", "feature_home_wallet_balance", setOf(
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1755, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 975, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1007, 63),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1759, 83),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 939, 51),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 915, 59),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 951, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1010, 55),
      ))
    }

internal val Res.string.home_filter_transactions: StringResource by lazy {
      StringResource("string:home_filter_transactions", "home_filter_transactions", setOf(
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1859, 104),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1039, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1071, 64),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1843, 104),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 991, 56),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 975, 60),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1007, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1066, 60),
      ))
    }

internal val Res.string.home_no_transactions_found: StringResource by lazy {
      StringResource("string:home_no_transactions_found", "home_no_transactions_found", setOf(
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 1964, 198),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1100, 118),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1136, 114),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 1948, 182),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 1048, 110),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1036, 114),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1060, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1127, 94),
      ))
    }

internal val Res.string.home_see_all: StringResource by lazy {
      StringResource("string:home_see_all", "home_see_all", setOf(
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 2163, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1219, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1251, 32),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2131, 56),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 1159, 36),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1151, 32),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1171, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1222, 32),
      ))
    }

internal val Res.string.home_transaction_history: StringResource by lazy {
      StringResource("string:home_transaction_history", "home_transaction_history", setOf(
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 2216, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1252, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1284, 68),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2188, 84),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 1196, 56),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1184, 68),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1204, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1255, 60),
      ))
    }

internal val Res.string.start_sending_your_money_tax_free: StringResource by lazy {
      StringResource("string:start_sending_your_money_tax_free", "start_sending_your_money_tax_free", setOf(
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 2309, 165),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1321, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1353, 101),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 2273, 145),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 1253, 81),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1253, 93),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 1265, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1316, 81),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_home_account_error", Res.string.feature_home_account_error)
  map.put("feature_home_account_number", Res.string.feature_home_account_number)
  map.put("feature_home_account_success", Res.string.feature_home_account_success)
  map.put("feature_home_account_type", Res.string.feature_home_account_type)
  map.put("feature_home_arrow_up", Res.string.feature_home_arrow_up)
  map.put("feature_home_autopay", Res.string.feature_home_autopay)
  map.put("feature_home_coin_image", Res.string.feature_home_coin_image)
  map.put("feature_home_desc", Res.string.feature_home_desc)
  map.put("feature_home_failed_to_load_accounts", Res.string.feature_home_failed_to_load_accounts)
  map.put("feature_home_loading", Res.string.feature_home_loading)
  map.put("feature_home_mark_default", Res.string.feature_home_mark_default)
  map.put("feature_home_no_account", Res.string.feature_home_no_account)
  map.put("feature_home_request", Res.string.feature_home_request)
  map.put("feature_home_request_money", Res.string.feature_home_request_money)
  map.put("feature_home_send", Res.string.feature_home_send)
  map.put("feature_home_send_money", Res.string.feature_home_send_money)
  map.put("feature_home_view_more", Res.string.feature_home_view_more)
  map.put("feature_home_wallet_balance", Res.string.feature_home_wallet_balance)
  map.put("home_filter_transactions", Res.string.home_filter_transactions)
  map.put("home_no_transactions_found", Res.string.home_no_transactions_found)
  map.put("home_see_all", Res.string.home_see_all)
  map.put("home_transaction_history", Res.string.home_transaction_history)
  map.put("start_sending_your_money_tax_free", Res.string.start_sending_your_money_tax_free)
}
